import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { DealersTable } from "@/features/dealers/components/DealersTable"

// 2026-04-24 — `?id=<guid>` deep-link.
const searchSchema = z.object({ id: z.string().optional() })

export const Route = createFileRoute("/_authed/dealers")({
  // Org-scoped kullanıcıya AÇIK (2026-08-04). Sayfa ADR #034 ile `SuperAdmin/orgs`
  // listesinin type=dealer projeksiyonuna çevrildi; o uç non-root caller'da kendi
  // subtree'sini döner, dolayısıyla eski admin-only yönlendirmesi gereksizdi.
  component: DealersPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function DealersPage() {
  const { t } = useTranslation("dealers")
  const { id } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <DealersTable initialSelectedId={id ?? null} />
    </div>
  )
}
